import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.4);
    opacity: 0.8;
  }
`;

const HotspotContainer = styled.div`
  position: absolute;
  left: ${props => props.x};
  top: ${props => props.y};
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 50;
  
  /* Mobile positioning adjustments */
  @media (max-width: 768px) {
    /* Adjust position for mobile to stay over the t-shirt */
    left: ${props => props.mobileX || props.x};
    top: ${props => props.mobileY || props.y};
  }
  
  @media (max-width: 480px) {
    left: ${props => props.mobileX || props.x};
    top: ${props => props.mobileY || props.y};
  }
`;

const HotspotWrapper = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }
  
  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

const HotspotDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* NO ANIMATION - static dot */
  
  /* Responsive sizing */
  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    box-shadow: 0 0 18px rgba(255, 255, 255, 0.7);
  }
  
  @media (max-width: 480px) {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
  }
`;

const HotspotRing = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  animation: ${pulse} 2s ease-in-out infinite;
  /* ONLY the ring pulses */
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 10px;
  border-radius: 15px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease;
  pointer-events: none;
  
  /* Mobile adjustments */
  @media (max-width: 768px) {
    bottom: 30px;
    font-size: 12px;
    padding: 8px 12px;
  }
`;

function Hotspot({ position, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <HotspotContainer 
      x={position.x} 
      y={position.y}
      mobileX={position.mobileX}
      mobileY={position.mobileY}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onTouchStart={() => setHovered(true)}
      onTouchEnd={() => setHovered(false)}
      onClick={onClick}
    >
      <HotspotWrapper>
        <HotspotRing />
        <HotspotDot />
      </HotspotWrapper>
      <Tooltip show={hovered}>
        Shop Now
      </Tooltip>
    </HotspotContainer>
  );
}

export default Hotspot; 